import { useTranslation } from 'next-i18next'

import { Link } from '~/components'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ArrowLeftBoldIcon from '~/components/Icons/svgs/ArrowLeftBoldIcon'
interface Props {
  pageTitle: string
  href: string
}

export function BackButton({ pageTitle, href }: Props): React.ReactElement {
  const { t } = useTranslation('generics')
  const buttonName = t('backTo', { pageTitle })

  return (
    <div className="flex flex-wrap mb-4">
      <Link to={href}>
        <div className="inline-flex items-center gap-2 text-white">
          <SVGIcon icon={ArrowLeftBoldIcon} pathClassName="text-white" />
          <span>{buttonName}</span>
        </div>
      </Link>
    </div>
  )
}
